import React from "react";
// import { useNavigate } from "react-router-dom";
import { KeyFeaturesConstants } from "./KeyFeaturesConstants";
import FeatureCard from "../featureCards/FeatureCard";
import { FeatureCardConstants } from "../featureCards/FeatureCardConstants";
import "./KeyFeatures.scss";

const KeyFeatures: React.FC = () => {

    const { keyFeatures } = KeyFeaturesConstants;


    return (
        <section className="key-features">
            <div className="key-features-container">
                <div className="key-features-header">
                    <div className="key-features-badge">
                        <img className="badge-icon" src={keyFeatures.icon} alt="Fire icon" />
                        <span className="badge-text">{keyFeatures.badge}</span>
                    </div>
                    <h2 className="key-features-title">
                        {keyFeatures.title}
                    </h2>
                    {/* <p className="key-features-description">
                        {keyFeatures.description}
                    </p> */}
                </div>
                <div className="feature-cards-grid">
                    {FeatureCardConstants.features.map((feature, index) => (
                        <FeatureCard
                            key={feature.id}
                            feature={feature}
                            stickyIndex={index}
                            enableStickyStack
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default KeyFeatures;

